




































import { Component, Prop, Vue } from 'vue-property-decorator';
import SearchQuotation from '@/components/searchQuotation.vue';
import SelectProject from '@/components/selectProject.vue';
import SelectIssue from '@/components/selectIssue.vue';
import SearchRequirement from '@/components/searchRequirement.vue';
import SelectModule from '@/components/selectModule.vue';

@Component({
  components: {
    SearchQuotation,
    SelectProject,
    SelectIssue,
    SearchRequirement,
    SelectModule,
  },
})
export default class SearchModal extends Vue {
  @Prop({default: () => ([])}) private searchKeys!: string[];
  private visible = false;
  // private title = '搜索';
  private searchParams: any = {};
  public showModal() {
    this.visible = true;
    this.searchParams = {};
  }
  private submitSearch() {
    this.visible = false;
    if (this.searchKeys.length > 0) {
      this.$emit('submit', this.searchParams);
    }
  }
  private handleQuotationChange(quotationInfo: ISolution.IResponse.ISolutionInfo | null) {
    if (quotationInfo) {
      this.searchParams.quotationId = quotationInfo.id;
    } else {
      delete this.searchParams.quotationId;
    }
  }
  private handleProjectChange(projectInfo: IProject.IResponse.IProjectInfo) {
    if (projectInfo) {
      this.searchParams.projectId = projectInfo.id;
    } else {
      delete this.searchParams.projectId;
    }
  }
  private handleIssueChange(issueInfo: IIssue.IResponse.IIssueInfo) {
    if (issueInfo) {
      this.searchParams.issueId = issueInfo.id;
    } else {
      delete this.searchParams.issueId;
    }
  }
  private handleRequirementChange(requirementInfo: IRequirement.IResponse.IRequirementInfo) {
    if (requirementInfo) {
      this.searchParams.requirementId = requirementInfo.id;
    } else {
      delete this.searchParams.requirementId;
    }
  }
  private handleModuleChange(moduleInfo: IModule.IResponse.IModuleInfo) {
    if (moduleInfo) {
      this.searchParams.moduleId = moduleInfo.id;
    } else {
      delete this.searchParams.moduleId;
    }
  }
}
